<script setup lang="ts">
import { useI18n } from "vue-i18n";
import { useStore } from "../../../store/index";
import { ref, watchEffect } from "vue";
import { addRetargetingScripts } from "../../../utils/retargeting";
import "vue3-circle-progress/dist/circle-progress.css";
import CircleProgress from "vue3-circle-progress";
import { pushEmail } from "../../../utils/pu";
import { decodeBase64Email } from "../../../utils/utils";

const { t } = useI18n();
const store = useStore();

const orientation = ref(store.urlParameters?.orientation.split("-")[0]);

const state = ref(store.state).value;
const istate =
	ref(store.urlParameters?.flow).value === "noemailstate" && state
		? true
		: false;

const progressBar = ref(0);

const isLoading = ref(false);
const trackingDomain = store.trackingDomain;
const ag_custom_email = store.urlParameters?.ag_custom_email;

function updateProgressBar() {
	const increment = ref(100 / 110);

	const intervalId = setInterval(() => {
		progressBar.value += increment.value;

		if (progressBar.value >= 100) {
			clearInterval(intervalId);
		}
	}, 1);
}

async function clickButton() {
	isLoading.value = true;
	updateProgressBar();
	addRetargetingScripts();

	if (store.pu === "fbk" && ag_custom_email !== undefined) {
		const email = decodeBase64Email(ag_custom_email) || ag_custom_email;

		const puUrl = await pushEmail(
			email,
			store.urlParameters,
			window.location.host + window.location.pathname,
		);

		if (puUrl) {
			window.open(`https://${trackingDomain}/click`, "_blank");
			window.location.href = puUrl;
			return;
		}
	}

	setTimeout(() => {
		window.location.href = `https://${trackingDomain}/click`;
	}, 2000);
}
</script>

<template>
	<div class="flex flex-col items-center w-full space-y-5 text-center mt-7">
		<h1
			class="text-[#626c72] text-2xl font-normal tracking-[0.2rem] md:font-semibold uppercase"
			v-html="
				istate
					? t(`noEmail.${orientation}.text1state`, { state: state })
					: t(`noEmail.${orientation}.text1`)
			"
		></h1>

		<h2
			class="text-[#677277] tracking-[0.2rem] uppercase"
			v-html="
				istate
					? t(`noEmail.${orientation}.text2state`, { state: state })
					: t(`noEmail.${orientation}.text2`)
			"
		></h2>
		<button
			:disabled="isLoading"
			class="border border-[#cbcfd2] py-2 px-6 rounded-md text-sm hover:border-red-400 hover:text-red-400 duration-200 uppercase font-bold flex flex-row justify-center items-center space-x-2"
			@click="clickButton"
		>
			<circle-progress
				:percent="progressBar"
				fill-color="#9ccc65"
				:size="30"
				:border-width="5"
				:border-bg-width="5"
				:transition="200"
			/>
			<span>
				{{ t(`noEmail.${orientation}.button`) }}
			</span>
		</button>
	</div>
</template>
